import React, { useContext, useEffect, useState, useCallback } from 'react';
import { I18nContext } from 'translations';
import Title from 'components/Titles';
import CompanyRegisterForm from './CompanyRegisterForm';
import {
  Chip,
  Snackbar,
} from '@material-ui/core';
import {
  getCompanyRegister,
  closeMessage,
  getTaxLiabilityOptions,
  getMaxDeclaredValueOptions 
} from 'context/settings/companyRegister/actions';
import { useStateValue } from 'context/store';
import Loading from 'components/Loading';
import { COUNTRIES_IDS_BY_NAME } from 'utils/constants';

const CompanyRegister = () => {
  const { translate } = useContext(I18nContext);
  const [
    {
      checkin: { checkin },
      companyRegister: { getLoading, postLoading, data, message, maxDeclaredValueOptions },
    },
    dispatch,
  ] = useStateValue();

  const [formKey, setFormKey] = useState(0);

  useEffect(() => {
    if (checkin?.company) {
      const { _id, geo_fence_id } = checkin.company;

      getCompanyRegister(dispatch, _id);
      getMaxDeclaredValueOptions(dispatch, _id);

      const isColombiaOrMexico = [COUNTRIES_IDS_BY_NAME.colombia._id, COUNTRIES_IDS_BY_NAME.mexico._id].includes(geo_fence_id);
      if (isColombiaOrMexico) {
        getTaxLiabilityOptions(dispatch, _id);
      }
    }
  }, [checkin.company]); // eslint-disable-line

  const handleSuccess = useCallback(() => {
    if (checkin?.company) {
      getCompanyRegister(dispatch, checkin.company._id);
    }
    setFormKey((prev) => prev + 1);
  }, [dispatch, checkin?.company]); // eslint-disable-line

  return (
    <>
      <Title title={translate('app.setting.companyRegister.status.title')} />
      {postLoading && <Loading />}
      {getLoading ? (
        <Loading />
      ) : (
        checkin?.company && (
          <>
            <Chip
              label={translate(
                `app.setting.companyRegister.status.${data?.registration_status}`
              )}
              color={
                data?.registration_status === 'refused'
                  ? 'secondary'
                  : 'primary'
              }
              style={{ margin: '2rem 0' }}
            />
            {
              maxDeclaredValueOptions &&
              <CompanyRegisterForm
                key={formKey}
                company={checkin?.company}
                companyRegister={data}
                maxDeclaredValueOptions={maxDeclaredValueOptions}
                onSuccess={handleSuccess}
              />
            }
          </>
        )
      )}

      <Snackbar
        open={!!message}
        autoHideDuration={6000}
        onClose={() => closeMessage(dispatch, null)}
        message={translate(message)}
      />
    </>
  );
};

export default CompanyRegister;
